define("shared/utils/insert-text-at-cursor", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.insertTextAtCursor = insertTextAtCursor;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  /**
   * Inserts text at the current cursor position in a textarea.
   *
   * @see https://kubyshkin.name/posts/insert-text-into-textarea-at-cursor-position/
   *
   * @param textarea The textarea to insert text into
   * @param text The text to insert
   */
  function insertTextAtCursor(textarea, text) {
    const start = textarea.selectionStart;
    textarea.setRangeText(text); // update cursor to be at the end of insertion

    textarea.selectionStart = start + text.length;
    textarea.selectionEnd = start + text.length; // Notify any possible listeners of the change

    const event = new UIEvent('input', {
      bubbles: true,
      cancelable: false
    });
    textarea.dispatchEvent(event);
  }
});